import React, { useState } from "react";
import KeysTable from "./KeysTable";
import KeysForm from "./KeysForm";

export default function Keys() {
  const [refresh, setRefresh] = useState(false);
  const [keysCount, setKeysCount] = useState(0);

  // Trigger table refresh
  const handleRefresh = () => setRefresh((prev) => !prev);

  return (
    <div className="min-h-screen flex flex-col">
      <main className="flex-1">
        <div className="mx-auto px-4 py-4 md:py-6 space-y-4 md:space-y-6">
          <section
            className={`grid grid-cols-1 gap-4 md:gap-5 ${
              keysCount > 0 ? "" : "lg:grid-cols-3"
            }`}
          >
            {/* Table */}
            <div
              className={`flex flex-col gap-4 ${
                keysCount > 0 ? "lg:col-span-3" : "lg:col-span-2"
              }`}
            >
              <KeysTable
                refresh={refresh}
                onUpdate={handleRefresh}
                onKeysCountChange={setKeysCount}
              />
            </div>

            {/* Form */}
            {keysCount === 0 && (
              <div className="flex flex-col gap-4">
                <KeysForm onSuccess={handleRefresh} />
              </div>
            )}
          </section>
        </div>
      </main>
    </div>
  );
}


